import {
  Line,
  mixins
} from 'vue-chartjs'
const {
  reactiveProp
} = mixins

import zoom from 'chartjs-plugin-zoom';

const zoomPluginOpts = {
  zoom: {
    // Boolean to enable zooming
    enabled: true,
    // drag: true,
    
    // Zooming directions. Remove the appropriate direction to disable 
    // Eg. 'y' would only allow zooming in the y direction
    mode: 'xy',
    // sensitivity: 100,
  },
  pan: {
    enabled: true,
    mode: 'xy',
    speed: 20,
    threshold: 10
  }
};

export default Line.extend({
  mixins: [reactiveProp],
  props: ['options'],
  watch: {
    'options': {
      handler(newOption, oldOption) {
        this._chart.destroy()
        this.renderChart(this.chartData, Object.assign({}, this.options, zoomPluginOpts));
      },
      deep: true
    }
  },
  mounted() {
    this.addPlugin(zoom);
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, Object.assign({}, this.options, zoomPluginOpts));
  }
})



// WEBPACK FOOTER //
// ./src/components/Charts/LineChart.js